import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import ComponentActions from "./ComponentActions";
import BalanceSheetTable from "../../Common/Tables/BalanceSheetTable";

class BalanceSheetComponent extends Component {
  render() {
    const {
      slideId,
      isPreparePresentation,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      hasExplanation,
      component: { componentId, labels, data, config }
    } = this.props;

    return (
      <div>
        <ComponentHeader
          slideId={slideId}
          percentage={false}
          title={labels}
          annexeAttachmentCategory={config.annexeAttachmentCategory}
          handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
          isPresentation={isPresentation}
          hasComments={hasComments}
          componentId={componentId}
          isPreparePresentation={isPreparePresentation}
          indicatorsExplanation={indicatorsExplanation}
          hasExplanation={hasExplanation}
          inSlideView={this.props.inSlideView}
        />
        <div
          className={classnames(
            styles.BalanceSheetComponent,
            // styles.absolute_container,
            styles.flex_container,
            styles.align_container
          )}
          // style={{ top: config.PositionTop ? config.PositionTop : "63%" }}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"NumberOfYearsComponentConfig"}
                component={"BalanceSheetComponent.png"}
              />
            )}
          <span
            className={classnames(
              "medium-12 small-12"
              // styles.flex_container,
              // styles.align_container
            )}
          >
            <BalanceSheetTable componentData={data} />
          </span>
        </div>
      </div>
    );
  }
}

export default BalanceSheetComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/BalanceSheetComponent.js